export const apiUrl = 'https://api.gamesfi.live';

export const isAuthGuardActive = false;